import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/pages/Dashboard';
import HelloTest from '@/pages/HelloTest';

import Tickets from '@/pages/tickets/Tickets';
import SingleTicket from '@/pages/tickets/SingleTicket';
import AllTickets from '@/pages/tickets/AllTickets';
import MyTickets from '@/pages/tickets/MyTickets';

import Companies from '@/pages/companies/Companies';
import CreateCompany from '@/pages/companies/CreateCompany';
import SingleCompany from '@/pages/companies/SingleCompany';

import Contacts from '@/pages/contacts/Contacts';
import SingleContact from '@/pages/contacts/SingleContact';

import Login from '@/pages/authentication/Login';
import ForgotPassword from '@/pages/authentication/ForgotPassword';
import Register from '@/pages/authentication/Register';
import Logout from '@/pages/authentication/Logout';

Vue.use(Router);

const router = new Router({
  linkExactActiveClass: 'is-active',
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
    },
    {
      path: '/test',
      name: 'HelloTest',
      component: HelloTest,
    },
    {
      path: '/tickets/all',
      name: 'AllTickets',
      component: AllTickets,
    },
    {
      path: '/tickets/mine',
      name: 'MyTickets',
      component: MyTickets,
    },
    {
      path: '/tickets',
      name: 'Tickets',
      component: Tickets,
    },
    {
      path: '/tickets/:id',
      name: 'Ticket',
      component: SingleTicket,
    },
    {
      path: '/companies',
      name: 'Companies',
      component: Companies,
    },
    {
      path: '/companies/create',
      name: 'CreateCompany',
      component: CreateCompany,
    },
    {
      path: '/companies/:id',
      name: 'SingleCompany',
      component: SingleCompany,
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: Contacts,
    },
    {
      path: '/contacts/:id',
      name: 'SingleContact',
      component: SingleContact,
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Before each route change check if user is logged in
  const loggedIn = localStorage.getItem('user');
  const publicPages = ['/login', '/forgot-password', '/register'];
  const authRequired = !publicPages.includes(to.path);

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js